import React from 'react';
import PropTypes from 'prop-types';
import jMoment from 'components/classes/Jmomen';
import Field from 'components/common/Field';
import RangePicker from 'components/common/DatePicker/RangePicker';
import {Modal, Row, Col, Form as AntdForm, Input, Radio, Select, Button} from 'antd';
import uuidv1 from 'uuid/v1';
import AssignmentComponent from 'components/common/Assignment';
import {connect} from 'react-redux';
import {index, emptySettings} from '../Definition/Module';
import {store, index as getAssign, emptySettingPacks} from './Module';
import MaterialIcon from 'components/common/MaterialIcon';
import Spin from 'components/common/Spin';

@connect((state) => ({
  items: state.Attendance.Setting.Definition.settingPacks,
  values: state.Attendance.Setting.Assignment.settingPacks,
}), {
  index,
  store,
  getAssign,
  emptySettings,
  emptySettingPacks,
})
@autobind
/**
 *
 */
export default class Assignment extends React.PureComponent {
  static propTypes = {
    assigner: PropTypes.object,
    items: PropTypes.arrayOf(PropTypes.object),
    values: PropTypes.arrayOf(PropTypes.object),
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    component: PropTypes.string,
  };

  static defaultProps = {
    assigner: {},
    items: [],
    values: [],
    component: 'user',
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  /**
   *
   */
  componentDidMount() {
    this._onReload();
  }


  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptySettings();
    this.props.emptySettingPacks();
  }

  /**
   *
   * @private
   */
  _onReload() {
    const {index, component, getAssign, assigner} = this.props;
    this.setState({loading: true}, () => {
      index(null, () => getAssign(component, assigner && assigner.id, {}, () => this.setState({loading: false})));
    });
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const loading = this.state.loading;
    const {items, onCancel, component, store, assigner, values} = this.props;
   let title = assigner.type ?
     ` - ${assigner.name}${assigner.user && assigner.user.profile ? ` - ${assigner.user.profile.firstName} ${assigner.user.profile.lastName}` : '' }` :
   `${assigner.profile ? ` - ${assigner.profile.firstName} ${assigner.profile.lastName}`: '' }`;

    return (
      <Spin
        spinning={loading}
      >
        <AssignmentComponent
          title={`${app.translate('routes.home.attendance.setting.Setting')}${title}`}
          calendarTitle='روزهای تقویم'
          disabledMsg={'گرفته شده از پدر'}
          titleKey={'name'}
          idKey={component === 'user' ? 'dateAssignmentableId': 'id'}
          list={items}
          values={values}
          updatePermission={true}
          onCancel={onCancel}
          onSubmit={(value) => {
            let data = {user: {}, positions: []};
            let _data = {
              ...assigner,
              setting_packs: value,
            };

            if (component === 'user') {
              data.user = _data;
            } else {
              data.positions = [_data];
            }

            store({data}, onCancel);
          }}
          disabledItem={(item) => item && item.forParent ? item.forParent : false}

        />
      </Spin>
    );
  }
}
